import React, { useState } from 'react';
import { useUrlSearchParams } from "use-url-search-params";
import { useTranslation } from "react-i18next";

import { useFunctionTasks } from "modules/functionRegister/hooks";

import {Breadcrumb, Table, Typography} from 'antd';

import Pagination from "containers/Pagination";

import Title from "components/Title";
import Spacer from "components/Spacer";
import Container from "components/Container";

import FilterList from "./components/FilterList";

function prepareLexHtml(html) {
    if (!html) return '';
    return html.replace(
        /href=["'](?!https?:\/\/)([^"']+)["']/gi,
        (_, href) => `href="https://lex.uz/docs/${href}" target="_blank" rel="noopener noreferrer"`
    );
}

const FunctionTasks = () => {
    const { t, i18n } = useTranslation();

    const [params, setParams] = useUrlSearchParams();
    const [search, setSearch] = useState(0);

    const defaultParams = {
        search,
        page: params.page,
        perPage: params.perPage,
        filter: [
            {
                key: 'mainLexData.content.uz',
                operation: '%_%',
                value: params.content_uz,
                type: 'JSON'
            },
            {
                key: "organization_id",
                operation: "=",
                value: params.organization_id,
                type: "NUMBER",
            },
            {
                key: 'can_be',
                operation: '=',
                value: params.can_be,
                type: 'STRING'
            },
            {
                key: 'type',
                operation: '=',
                value: params.type,
                type: 'STRING'
            }
        ],
    }

    const { items: functionTasks, meta, isFetched: isFunctionTasksFetched } = useFunctionTasks({
        params: defaultParams,
    });

    return (
        <Container>
            <Spacer size={35} />

            <Breadcrumb separator=">">
                <Breadcrumb.Item href='/'>{t('home')}</Breadcrumb.Item>
                <Breadcrumb.Item >{t('function_tasks')}</Breadcrumb.Item>
            </Breadcrumb>

            <Spacer size={32} />

            <Title align='left' text={t('function_tasks')} />

            <Spacer size={40} />

            <FilterList {...{ params, setParams, setSearch }} />
            <Spacer size={20} />

            <Table
                rowKey="id"
                defaultSort="-id"
                columns={[
                    {
                        title: "№",
                        render: (_, __, index) =>
                            (meta.current - 1) * meta.perPage + index + 1,
                    },
                    {
                        key: 'main_lex_data',
                        title: t('column_name'),
                        dataIndex: 'main_lex_data',
                        width: '700px',
                        render: (_, item) => <div dangerouslySetInnerHTML={{ __html: prepareLexHtml(item?.mainLexData?.content?.uz) }} />
                        //
                    },
                    {
                        key: "organization",
                        title: t("column_organization"),
                        dataIndex: ["organization", "name", i18n.language],
                    },
                    {
                        key: 'main_lex_data',
                        title: t('column_main_document'),
                        dataIndex: 'main_lex_data',
                        render: (_, item) => (
                            <>
                                <Typography>{item?.mainLexData?.docNumber}</Typography>
                                <Typography>{item?.mainLexData?.basisDate}</Typography>
                            </>
                        )
                    },
                    {
                        key: 'type',
                        title: t('column_type'),
                        dataIndex: 'type',
                        width: '180px',
                        render: (v, item) => <Typography>{t(item?.type)}</Typography>
                    },
                    {
                        key: 'can_be',
                        title: t('column_can_be'),
                        dataIndex: 'can_be',
                        render: (v, item) => <Typography>{item.canBe ? t(item.canBe) : "Yo'q"}</Typography>
                    }
                ]}
                dataSource={functionTasks}
                pagination={false}
                loading={!isFunctionTasksFetched}
            />

            <Spacer size={32} />

            <Pagination
                current={meta.current}
                perPage={meta.perPage}
                total={meta.totalPages}
                currentItems={functionTasks.length}
                totalItems={meta.totalItems}
                onChange={(page) => setParams({ page })}
                onPerPageChange={perPage => setParams({ perPage })}
            />

            <Spacer size={140} />
        </Container>
    )
}

export default FunctionTasks;